import { GetterNames } from './keys'
import { PatientWithExerciseSummarysState, FlatPatientExerciseSummary } from './types'
import { flattenJsonApiResponse } from '@/store/utils/converter'
import { sortByPatientName } from '@/utils/patients'

export const getters = {
  [GetterNames.patientWithExerciseSummarys]: (
    state: PatientWithExerciseSummarysState
  ): FlatPatientExerciseSummary[] => {
    return state.patientWithExerciseSummarys.map(flattenJsonApiResponse)
  },

  [GetterNames.patientWithExerciseSummarysOrderedByFullName]: (state: PatientWithExerciseSummarysState) => {
    const normalizePatientName = patient => {
      if (patient.patientFirstName || patient.patientLastName) {
        return [patient.patientFirstName, patient.patientLastName]
          .filter(Boolean)
          .join('')
          .toLowerCase()
      } else {
        return patient.id
      }
    }
    return state.patientWithExerciseSummarys
      .map(flattenJsonApiResponse)
      .sort((a, b) => normalizePatientName(a).localeCompare(normalizePatientName(b)))
  },
}
